import { useTranslation } from 'react-i18next'
import React from 'react'
import {
  Body,
  BodyWrapper,
  Check,
  Container,
  Content,
  Footer,
  Header,
  TitleWrapper,
} from './styles'
import { formatDuration } from 'utils/duration'
import { Flixx, Card, Div, Button, Text } from 'ui'
import { useSession } from 'hooks'


const EpisodeCard = ({
  onClickCTA,
  onClick,
  cover,
  isSelected,
  title,
  duration,
  body,
  isPurchased,
  price
}) => {

  const { t } = useTranslation()
  const { isLoggedIn } = useSession()

  return (
    <Container>
      <Card
        onClick={() => {}}
        isSelected={isSelected}
        padding={16}
      >
        <Content>
          <Header onClick={onClick}>
            <img src={cover} alt={title} />

            <TitleWrapper>
              <div>
                <h3>{title}</h3>
                <p>{formatDuration(duration)} {t('min')}</p>
              </div>
            </TitleWrapper>
          </Header>

          <BodyWrapper onClick={onClick}>
            <Body>{body}</Body>
          </BodyWrapper>

          {isLoggedIn && (
            <Footer>
              <Div
                height='100%'
                minHeight='100%'
                onClick={onClick}
                display='grid'
                placeItems='end start'
                flexGrow={1}
                gap={6}
              >
                {isPurchased ? (
                  <Div height={40} display='flex' alignItems='center' gap={6}>
                    <Check />
                    <Text size='sm' color='headline'>
                      {t('bought')}
                    </Text>
                  </Div>
                ) : (
                  <Div height={40} display='flex' alignItems='center' gap={6}>
                    <Text size='sm' color='headline'>
                      {t('common:value')}:
                    </Text>
                    <Flixx size='sm' price={price} />
                  </Div>
                )}
              </Div>

              <Div paddingTop={16} display='flex' alignItems='end'>
                <Button onClick={onClickCTA} borderRadius={4}>
                  {t('watchNow')}
                </Button>
              </Div>
            </Footer>
          )}
        </Content>
      </Card>
    </Container>
  )
}

export default EpisodeCard
